import React from 'react'

import PanduanPerilakuKerjaApp from 'app/KinerjaKSPage/pages/Panduan/PerilakuKerja'
import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import { PENGELOLAAN_KINERJA_NOT_FOUND_PATH } from 'app/KinerjaShared/constants/path'

import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const enabled = toggle?.['kinerja-ks-enabled'] || false

    if (!enabled) {
      return {
        redirect: {
          destination: PENGELOLAAN_KINERJA_NOT_FOUND_PATH,
          permanent: false,
        },
      }
    }

    return { props: {} }
  },
})

const PanduanPerilakuKerja = () => {
  return <PanduanPerilakuKerjaApp />
}

PanduanPerilakuKerja.Layout = KinerjaLayout

PanduanPerilakuKerja.layoutOpts = {
  hasHeader: true,
}

export default PanduanPerilakuKerja
